<script>
import { VueDatePicker } from '@mathieustan/vue-datepicker';

export default {
    extends: VueDatePicker,

    data: () => ({
        windowWidth: window.innerWidth
    }),

    mounted() {
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth
        })
    },

    computed: {
        shouldShowBottomSheet() {
            return this.fullscreenMobile &&
                this.windowWidth <= 480;
        },
    }
}
</script>